import { cva } from '@/styled-system/css';

export const tableRowRecipe = cva({
  base: {
    verticalAlign: 'top',
  },
  compoundVariants: [
    {
      interactive: true,
      selected: false,
      css: {
        _hover: {
          '& > td, & > th': {
            backgroundColor: 'Table.Cell.bg.hover',
            color: 'Table.Cell.text.hover',
          },
        },
        _active: {
          '& > td, & > th': {
            backgroundColor: 'Table.Cell.bg.pressed',
            color: 'Table.Cell.text.pressed',
          },
        },
      },
    },
  ],
});
